export default __webpack_public_path__ + "static/media/Ostali 11.910e0f43.jpg";